import { Select as MuiSelect, SelectProps, styled } from "@mui/material";
import { forwardRef } from "react";

const StyledSelect = styled(MuiSelect)`
  &.Mui-disabled {
    background-color: ${({ theme }) =>
      theme.palette.mode === "dark" ? theme.palette.grey[700] : theme.palette.grey[300]};
  }
  & .MuiSelect-select {
    display: flex;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
` as unknown as typeof MuiSelect;

export const Select = forwardRef<HTMLDivElement, SelectProps<any>>(
  ({ children, ...props }, ref) => {
    return (
      <StyledSelect {...props} ref={ref}>
        {children}
      </StyledSelect>
    );
  }
);

Select.displayName = "Select";

export default Select;
